const STORAGE_KEY = 'plp-filters-hidden';

function readStoredState() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch (e) {
    return false;
  }
}

function writeStoredState(hidden) {
  try {
    sessionStorage.setItem(STORAGE_KEY, hidden ? 'true' : 'false');
  } catch (e) {
    // ignore
  }
}

function setButtonState(button, hidden) {
  button.setAttribute('aria-expanded', hidden ? 'false' : 'true');
  const showLabel = button.querySelector('[data-toggle-label="show"]');
  const hideLabel = button.querySelector('[data-toggle-label="hide"]');
  if (showLabel) showLabel.hidden = !hidden;
  if (hideLabel) hideLabel.hidden = hidden;
}

function applyState(wrapper, hidden) {
  if (wrapper.getAttribute('data-filters-hidden') !== (hidden ? 'true' : 'false')) {
    wrapper.setAttribute('data-filters-hidden', hidden ? 'true' : 'false');
  }
  const button = wrapper.querySelector('[data-plp-filter-toggle]');
  if (button) setButtonState(button, hidden);
}

function bindClickHandler(wrapper) {
  if (wrapper._plpToggleHandler) return;
  const handler = (event) => {
    const button = event.target.closest('[data-plp-filter-toggle]');
    if (!button || !wrapper.contains(button)) return;
    event.preventDefault();
    const nextHidden = wrapper.getAttribute('data-filters-hidden') !== 'true';
    applyState(wrapper, nextHidden);
    writeStoredState(nextHidden);
  };
  wrapper._plpToggleHandler = handler;
  wrapper.addEventListener('click', handler);
}

function syncWrapper(wrapper) {
  if (!wrapper) return;
  applyState(wrapper, readStoredState());
  bindClickHandler(wrapper);
}

// The toggle button is server-rendered inside the controls wrapper, so no
// relocation is needed. Horizon morphs the filters block on each facet change,
// which resets the button + wrapper to their default (shown) markup — re-apply
// the stored state when the controls wrapper re-appears.
function observe(wrapper) {
  if (wrapper._plpObserver) return;
  const observer = new MutationObserver((mutations) => {
    let needsSync = false;
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (
          node.matches?.('.facets-controls-wrapper.facets--horizontal') ||
          node.querySelector?.('.facets-controls-wrapper.facets--horizontal')
        ) {
          needsSync = true;
          break;
        }
      }
      if (needsSync) break;
    }
    if (needsSync) syncWrapper(wrapper);
  });
  observer.observe(wrapper, { childList: true, subtree: true });
  wrapper._plpObserver = observer;
}

function bootstrapAndObserve() {
  document.querySelectorAll('.collection-wrapper').forEach((wrapper) => {
    syncWrapper(wrapper);
    observe(wrapper);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapAndObserve);
} else {
  bootstrapAndObserve();
}

document.addEventListener('shopify:section:load', bootstrapAndObserve);

// Catch collection wrappers added wholesale (e.g. section re-render).
const bodyObserver = new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches?.('.collection-wrapper')) {
        syncWrapper(node);
        observe(node);
      } else {
        node.querySelectorAll?.('.collection-wrapper').forEach((wrapper) => {
          syncWrapper(wrapper);
          observe(wrapper);
        });
      }
    }
  }
});

bodyObserver.observe(document.body, { childList: true, subtree: true });
